export const IS_BROWSER_FIREFOX = navigator.userAgent.includes("Firefox");
